import React from "react";
import { useNavigate } from "react-router-dom";
import {
  ClockCircleOutlined,
  FileTextOutlined,
  CheckCircleOutlined,
  CalendarOutlined,
  ArrowRightOutlined,
  ToolOutlined,
} from "@ant-design/icons";
import { STATUS_META, bookingText, encodeCode, usePortalExams } from "../../components/portalUtils";
import { Loader, ErrorBox } from "../../components/PortalBits";

const iconStyle = { marginRight: 6 };

function MyExams() {
  const navigate = useNavigate();
  const { loading, error, exams, reload } = usePortalExams();

  const open = (exam) => navigate(`/user-panel/dashboard/${encodeCode(exam.exam_code)}`, { state: { from: "/user-panel" } });

  return (
    <>
      <div className="page-head">
        <h2>My exams</h2>
        <div className="sub">All the certifications you're currently enrolled in. Select one to continue.</div>
      </div>
      {/* 
      {loading && <Loader />}
      {!loading && error && <ErrorBox message={error} onRetry={() => reload()} />}
      {!loading && !error && exams.length === 0 && (
        <div className="panel">
          <div className="empty-state">
            You're not enrolled in any exams yet.{" "}
            <button type="button" className="cbook-link-btn" onClick={() => navigate("/user-panel/explore-certifications")}>
              Explore our certifications <ArrowRightOutlined />
            </button>
          </div>
        </div>
      )} */}


      {loading && <Loader />}
      {!loading && exams.length === 0 && (
        <div className="panel">
          <div
            className="maintenance-notice"
            style={{
              maxWidth: 560,
              margin: "40px auto",
              padding: 32,
              textAlign: "center",
              border: "1px solid #ffe58f",
              background: "#fffbe6",
              borderRadius: 12,
            }}
          >
            <ToolOutlined style={{ fontSize: 36, color: "#faad14", marginBottom: 16 }} />
            <h3 style={{ margin: "0 0 12px",color:"black" }}>Notice: User Dashboard Under Maintenance</h3>
            <p style={{ margin: "0 0 12px",color:"black", lineHeight: 1.6 }}>
              The User Dashboard is currently under maintenance. If you have purchased an exam
              and booked your examination slot, your details will appear on the dashboard shortly.
              We appreciate your patience and understanding.
            </p>
            <p style={{ margin: 0,color:"black" }}>
              For any further clarification or queries contact support at{" "}
              <a href="mailto:info@cyberfrat.com">info@cyberfrat.com</a>.
            </p>
          </div>
        </div>
      )}

      {!loading && !error && exams.length > 0 && (
        <div
          className="exam-grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))",
            gap: 24,
          }}
        >
          {exams.map((ex) => {
            const meta = STATUS_META[ex.status] || STATUS_META.available;
            const showAppt = (ex.status === "scheduled" || ex.status === "expired") && ex.booking?.confirmed;
            return (
              <div
                key={ex.exam_code}
                className="exam-tile"
                role="button"
                tabIndex={0}
                onClick={() => open(ex)}
                onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && open(ex)}
                style={{ padding: 28, minHeight: 240, cursor: "pointer" }}
              >
                <div className="status-row" style={{ marginTop: 0 }}>
                  <div className="code" style={{ fontSize: 16 }}>{ex.exam_code}</div>
                  <span className="tile-pill" style={{ background: meta.fill, color: meta.text }}>{meta.label}</span>
                </div>
                <h3 style={{ fontSize: 20, margin: "16px 0" }}>{ex.full_name}</h3>
                <div className="meta" style={{ fontSize: 15, gap: 14 }}>
                  {ex.duration_minutes ? (
                    <span><ClockCircleOutlined style={iconStyle} />{ex.duration_minutes} min</span>
                  ) : null}
                  <span><FileTextOutlined style={iconStyle} />{ex.questions} Qs</span>
                  <span><CheckCircleOutlined style={iconStyle} />{ex.passing_percentage}% to pass</span>
                </div>
                {showAppt && (
                  <div className="tile-appt">
                    <CalendarOutlined style={iconStyle} />
                    {bookingText(ex.booking)}
                  </div>
                )}
                <div className="status-row">
                  {/* attempts left are not shown to candidates */}
                  <span className="tile-attempts" />
                  <span className="tile-arrow">
                    <ArrowRightOutlined style={{ fontSize: 18 }} />
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

export default MyExams;